const LoadJsCssFile = (filename, filetype, dom, async) => {
    if (filetype === 'js') {
        // if filename is a external JavaScript file
        var fileref = dom.createElement('script');
        fileref.setAttribute('type', 'text/javascript');
        fileref.setAttribute('src', filename);
        if (async === true) {
            fileref.setAttribute('async', '');
        }
    } else if (filetype === 'css') {
        // if filename is an external CSS file
        var fileref = dom.createElement('link');
        fileref.setAttribute('rel', 'stylesheet');
        fileref.setAttribute('type', 'text/css');
        fileref.setAttribute('href', filename);
    }
    if (typeof fileref !== 'undefined') {
        dom.getElementsByTagName('head')[0].appendChild(fileref);
    }
};

export default LoadJsCssFile;
